import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { VideoPlayerModal, VideoThumb } from '@wit-support/ui';
const KIND_LABEL_RU = {
    clip: 'клип',
    publication: 'ролик',
};
/**
 * Превью видео «Контента»: наведение — играет без звука по кругу, уход —
 * пауза и в начало, клик — полный просмотр в модальном плеере (Esc/фон/✕
 * закрывают и ставят на паузу). Одна обёртка для клипа и публикации — экраны
 * передают только адреса.
 */
export function ContentPreview({ kind, src, poster, title, description, details, size = 'xs', preparing = false, className, }) {
    const [open, setOpen] = React.useState(false);
    const label = `${KIND_LABEL_RU[kind]} ${title}`;
    return (_jsxs(_Fragment, { children: [_jsx(VideoThumb, { src: src, poster: poster ?? null, label: label, size: size, preparing: preparing, ...(className ? { className } : {}), ...(src !== null ? { onOpen: () => setOpen(true) } : {}) }), src !== null ? (_jsx(VideoPlayerModal, { open: open, onOpenChange: setOpen, src: src, poster: poster ?? null, title: title, ...(description != null ? { description } : {}), children: details })) : null] }));
}
//# sourceMappingURL=content-preview.js.map